import React, { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";

import { useNavigate, useSearchParams } from "react-router-dom";

import { setAdvertisementFilters } from "../../../store/advertisementFilterSlice";

import classes from "./advertisementFilterPage.module.css";
import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";

export const moduleArray = [
  { id: "", label: "Select Module" },
  { id: "home", label: "Home" },
  { id: "vrp", label: "VRP" },
  { id: "spares", label: "Spares" },
  { id: "open_box", label: "Open Box" },
  { id: "new_phone", label: "New Phone" },
];

export const pageArray = [
  { id: "", label: "Select Page" },
  { id: "landing", label: "Landing" },
  { id: "listing", label: "Listing" },
  { id: "detail", label: "Detail" },
];

export const AdvertisementFilterPage = ({ filters }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const categoryParam = searchParams.get("category");
    const pageParam = searchParams.get("page");

    dispatch(
      setAdvertisementFilters({
        category: categoryParam || null,
        page: pageParam || null,
      })
    );
  }, [searchParams, dispatch]);

  const updateFilterParams = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value) newSearchParams.set(key, value);
    else newSearchParams.delete(key);
    setSearchParams(newSearchParams);
  };

  const handleSelection = (identifier, selectedOptionId) => {
    updateFilterParams(identifier, selectedOptionId);
  };
  const handleAddAdvertisement = useCallback(() => {
    // console.log(rowData)
    navigate("/advertisement/create");
  }, [navigate]);

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
        <h1 className={classes.box__content__title}>Advertisements</h1>
      </div>
      <div className={classes.box__content}>
        <CustomDropdown
          id="category"
          label="Select Module"
          options={moduleArray}
          selectedId={filters.category || ""}
          onSelection={handleSelection}
        />
      </div>
      <div className={classes.box__content}>
        <CustomDropdown
          id="page"
          label="Select Page"
          options={pageArray}
          selectedId={filters.page || ""}
          onSelection={handleSelection}
        />
      </div>

      <button className={classes.box__btn} onClick={handleAddAdvertisement}>
        Add Advertisement
      </button>
    </div>
  );
};
